/** returns Transfers Requests Status List
@return { Array }
*/
export const getRequestsStatusList = state => {
  return state.transfersRequestsStatusList
}

export const getSentRequestsList = state => {
  return state.transfersSentRequestsList
}

/** returns Account Movements hasMore value
@return { Boolean }
*/
export const getSentRequestsHasMore = state => state.transfersSentRequestsHasMore
